module.exports = __webpack_public_path__ + "static/media/Empty_Dock.1e1e036a.jpg";